import {
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Input,
  Radio,
  Row,
  Select,
  Space,
  Tooltip,
} from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { GoDeviceMobile } from "react-icons/go";
import { IoInformationCircleSharp } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import { error } from "../../contants/snackbars";
import { colorScheme, numberOfOwners } from "../../contants/variables";
import { fetchSiteSetting } from "../../stores/api_calls/about";
import { getCommaSeparatedTwoDecimalsNumber } from "../../stores/utils/formatNumber";
import "./carform.scss";
import UploadFile from "./UploadFile";
import VideoUploader from "./VideoUploader";

const FieldSuffix = (props) => {
  const { TooltipData, tooltipWidth } = props;
  return (
    <Tooltip
      title={() => {
        return <TooltipData />;
      }}
      placement="bottomRight"
      overlayInnerStyle={{ width: tooltipWidth, whiteSpace: "normal" }}
    >
      <IoInformationCircleSharp
        color={colorScheme.primary}
        style={{ fontSize: "20px" }}
      />
    </Tooltip>
  );
};

const CarDetails = (props) => {
  const [salesAgents, setSalesAgents] = useState([]);
  const [coeLeftYear, setCoeLeftYear] = useState(null);
  const [coeLeftMonth, setCoeLeftMonth] = useState(null);
  const [coeLeftDay, setCoeLeftDay] = useState(null);
  const [checkRegDate, setCheckRegDate] = useState(true);
  const [SiteSetting, setSiteSetting] = useState("");

  const {
    form,
    setForm,
    cities,
    brands,
    models,
    dealers,
    packages,
    isEdit,
    vehicleTypes,
    usedCarCategories,
    fuelTypes,
    saleAdvisers,
  } = props;

  const [loan, setLoan] = useState({
    loanAmount: 0,
    loanPeriod: 0,
    loanPercentage: 0,
    loanInterest: 0,
    carPrice: 0,
    downPayment: 0,
  });

  useEffect(() => {
    getSiteSetting();
  }, []);

  // useEffect(() => {
  //   if(form.registrationDate != null && isEdit ) {
  //     autoCoeLeftDate(moment(form.coeExpiryDate));
  //   }
  // }, [form.registrationDate != null, isEdit])

  useEffect(() => {
    setSalesAgents(form.productAgents);
  }, [form, isEdit]);

  const getSiteSetting = () => {
    const fetchSetting = fetchSiteSetting({ id: "6815aedce32b3fd36f06f6f9" });
    fetchSetting
      .then((res) => {
        if (res.data.success) {
          setSiteSetting(res?.data?.data);
        }
      })
      .catch((e) => {
        error("Failed to retrieve content");
      });
  };

  const handleUpdateAgent = (e) => {
    const { name, checked } = e.target;

    const contactNumber = name.contactnumber
      ? name.contactnumber
      : name.contactNumber;
    if (checked) {
      salesAgents.push({
        fullName: name.fullName,
        contactNumber: contactNumber,
        sorting: name.sorting,
      });
    } else {
      salesAgents = salesAgents.filter(
        (item) => item.fullName != name.fullName,
      );
    }
    console.log(salesAgents);
    setForm({ ...form, productAgents: salesAgents });
  };

  const handleFieldChange = (name, e) => {
    if (name == "engineCap") {
      let engineCap = e.target.value == "" ? 0 : e.target.value;
      if (engineCap.length <= 5 || engineCap == 0) {
        setForm({
          ...form,
          [name]: parseInt(engineCap),
        });
      }
    } else if (name == "power") {
      let power = e.target.value == "" ? 0 : e.target.value;
      if (power.length <= 6 || power == 0) {
        setForm({
          ...form,
          [name]: parseInt(power),
        });
        console.log(parseInt(power));
      }
    } else if (name == "manufacturedYear") {
      let manufacturedYear = e.target.value == "" ? 0 : e.target.value;
      if (manufacturedYear.length <= 6 || manufacturedYear == 0) {
        setForm({
          ...form,
          [name]: parseInt(manufacturedYear),
        });
        console.log(parseInt(manufacturedYear));
      }
    } else if (name == "numberOfOwners") {
      let numberOfOwners = e.target.value == "" ? 0 : e.target.value;
      if (numberOfOwners.length <= 6 || numberOfOwners == 0) {
        setForm({
          ...form,
          [name]: parseInt(numberOfOwners),
        });
        console.log(parseInt(numberOfOwners));
      }
    } else if (name == "driveRange") {
      let driveRange = e.target.value == "" ? 0 : e.target.value;
      if (driveRange.length <= 6 || driveRange == 0) {
        setForm({
          ...form,
          [name]: parseInt(driveRange),
        });
      }
    } else {
      setForm({
        ...form,
        [name]: e.target.value,
      });
    }
  };

  const handleNumberFieldChange = (name, e, maxLength = 7) => {
    // if(name == "arf") {
    //   let arf = e;
    //   if(arf && form.askingPrice) {
    //     calculateDepreciation(form.askingPrice, arf, form.registrationDate, form.coeExpiryDate, coeLeftYear, coeLeftMonth, coeLeftDay)
    //   }
    //   if(arf && arf > 0) {
    //     if(coeLeftYear > 0 && coeLeftMonth > 0) {
    //       form.deregValue = arf/2;
    //     } else {
    //       form.deregValue = 0;
    //     }
    //   }
    // }

    if (name == "askingPrice") {
      // console.log(e)
      let askingPrice = e;
      if (form.arf && askingPrice) {
        setLoan({
          ...loan,
          loanAmount: askingPrice * (SiteSetting.loan_percent / 100),
          carPrice: askingPrice,
          downPayment: askingPrice * ((100 - SiteSetting.loan_percent) / 100),
        });

        // calculateDepreciation(askingPrice, form.arf, form.registrationDate, form.coeExpiryDate, coeLeftYear, coeLeftMonth, coeLeftDay)
      }
    }

    if (e.length <= maxLength || e == 0) {
      if (name == "engineCap") {
        setForm({
          ...form,
          specifications: {
            ...form.specifications,
            [name]: { label: e + " CC", value: parseInt(e), type: "engine" },
          },
        });
      } else if (name == "peakPower") {
        setForm({
          ...form,
          specifications: {
            ...form.specifications,
            [name]: { label: e + " KW", value: parseInt(e), type: "engine" },
          },
        });
      } else {
        setForm({
          ...form,
          [name]: e,
        });
      }
    }
  };

  const handleSelectPackage = (value) => {
    setForm({ ...form, packageId: value });
  };

  const onDateFieldChange = (name, dateString) => {
    // if(name == "registrationDate") {
    //   autoCoeExpiryDate(dateString);
    // }

    // if(name == "coeExpiryDate") {
    //   autoCoeLeftDate(dateString);
    // }

    setForm({ ...form, [name]: dateString });
  };

  // const autoCoeExpiryDate = (dateString) => {
  //   let regDate = moment(dateString);
  //   let coeDate = regDate.add(10, 'y').subtract(1, 'days');
  //   let nowDate = moment();
  //   let years = coeDate.diff(nowDate, 'years');
  //   nowDate.add(years, 'years');
  //   let months = coeDate.diff(nowDate, 'months');
  //   nowDate.add(months, 'months');
  //   let days = coeDate.diff(nowDate, 'days');
  //   const coeLeftDate = years + ' years ' + months + ' months ' + days + ' days';
  //   form.coeLeftDate = coeLeftDate;
  //   form.coeExpiryDate = coeDate;

  //   setForm({...form, coeExpiryDate: coeDate, coeLeftDate: coeLeftDate})
  //   setCoeLeftYear(years);
  //   setCoeLeftMonth(months);
  //   setCoeLeftDay(days);
  //   if(checkRegDate == false) {
  //     calculateDepreciation(form.askingPrice, form.arf, dateString, coeDate, years, months, days);
  //   }
  //   setCheckRegDate(false);
  // }

  // const autoCoeLeftDate = (dateString) => {
  //   let coeDate = moment(dateString);
  //   let nowDate = moment();
  //   let years = coeDate.diff(nowDate, 'years');
  //   nowDate.add(years, 'years');
  //   let months = coeDate.diff(nowDate, 'months');
  //   nowDate.add(months, 'months');
  //   let days = coeDate.diff(nowDate, 'days');
  //   const leftDate = years + ' years ' + months + ' months ' + days + ' days';
  //   form.coeLeftDate = leftDate;
  //   setForm({...form, coeLeftDate: leftDate})

  //   const loanPeriodMonth = (years * 12) + months;

  //   setLoan({
  //     ...loan,
  //     loanAmount: form.askingPrice * (SiteSetting.loan_percent/100),
  //     loanPeriod: loanPeriodMonth <= 84 ? loanPeriodMonth : 84,
  //     loanPercentage: SiteSetting.loan_percent,
  //     loanInterest: form.is_commercial_vehicle ? SiteSetting.commercial_interest_rate_percent : SiteSetting.interest_rate_percent,
  //     carPrice: form.askingPrice,
  //     downPayment: form.askingPrice * ((100 - SiteSetting.loan_percent)/100),
  //   });

  //   setCoeLeftYear(years);
  //   setCoeLeftMonth(months);
  //   setCoeLeftDay(days);
  //   calculateDepreciation(form.askingPrice, form.arf, form.registrationDate, dateString, years, months, days);
  // }

  const onCheckboxChange = (name, e) => {
    setForm({
      ...form,
      [name]: e.target.checked,
    });
  };

  const handleDropdownChange = (name, value, label, type) => {
    if (type == "engine" || type == "transmission") {
      setForm({
        ...form,
        specifications: {
          ...form.specifications,
          [name]: { label: label, value: value, type: type },
        },
      });
    } else {
      setForm({
        ...form,
        [name]: value,
      });
    }
  };

  const handleRadioChange = (key, e) => {
    setForm((prev) => ({ ...prev, [key]: e.target.value }));
  };

  const handelVideoChange = (key, value) => {
    // console.log(key, value);
    setForm({ ...form, [key]: value });
  };

  const handleUploadSuccess = (key, url) => {
    setForm((prev) => ({
      ...prev,
      [key]: url,
    }));
  };

  // const isOverTenYears = (regDate, coeDate) => {
  //   const diffInYears = Math.abs(moment(regDate).diff(moment(coeDate), 'years'));
  //   // console.log(diffInYears);
  //   return diffInYears > 10;
  // };

  // const calculateDepreciation = (askingPrice, arfVAlue, registrationDate, coeExpiryDate, coeYear, coeMonth, coeDay) => {

  //   const overTenYear = isOverTenYears(registrationDate, coeExpiryDate);

  //   if(!overTenYear) {
  //     form.depreciationValue = "";
  //     let coeDate = moment(form.coeExpiryDate);
  //     let nowDate = moment();
  //     let leftMonths = coeDate.diff(nowDate, 'months');

  //     let halfArf = arfVAlue / 2;
  //     let leftPrice = askingPrice - halfArf;
  //     let totalMonthPrice = leftPrice / leftMonths;
  //     let result = totalMonthPrice * 12;

  //     form.depreciationValue = result > 0 ? result.toFixed(0) : 0;
  //     setForm({ ...form, depreciationValue: result > 0 ? result.toFixed(0) : 0});
  //   }else {
  //     form.depreciationValue = "";
  //     const calculatedMonths = (Number(coeYear) * 12) + Number(coeMonth);

  //     let result = (Number(askingPrice) / calculatedMonths) * 12;
  //     form.depreciationValue =result > 0 ? result.toFixed(0) : 0;

  //     setForm({ ...form, depreciationValue: result > 0 ? result.toFixed(0) : 0});
  //   }
  // }

  const handleMultipleDropdownChange = (name, value) => {
    setForm({
      ...form,
      [name]: value,
    });
  };

  useEffect(() => {
    if (form.coeLeftDate != null) {
      calculateLoan();
    }
  }, [SiteSetting, form.askingPrice, form.coeLeftDate, loan.loanAmount]);

  useEffect(() => {
    if (form.isHybrid) {
      setForm((prev) => ({ ...prev, option_label_1: "Hybrid Car" }));
    } else if (form.option_label_1 === "Hybrid Car") {
      setForm((prev) => ({ ...prev, option_label_1: undefined }));
    }
  }, [form.isHybrid]);

  useEffect(() => {
    if (form.isElectric) {
      setForm((prev) => ({ ...prev, option_label_1: "Electric Car" }));
    } else if (form.option_label_1 === "Electric Car") {
      setForm((prev) => ({ ...prev, option_label_1: undefined }));
    }
  }, [form.isElectric]);

  const calculateLoan = () => {
    const { loanAmount, loanInterest, loanPeriod } = loan;
    let installment = 0;

    if (loanAmount) {
      installment = Math.floor(
        (parseFloat(loanAmount) *
          (parseFloat(loanInterest) / 100) *
          (parseInt(loanPeriod) / 12) +
          parseFloat(loanAmount)) /
          parseInt(loanPeriod),
      );
    } else {
      installment = 0;
    }

    form.monthly_installment_price = installment;

    setForm({ ...form, monthly_installment_price: installment });
  };

  return (
    <div>
      <div className="header-container">
        <p className="header">Dealer Personal Details</p>
        <p className="sub-header">
          note: (*) fields are required to be filled up
        </p>
      </div>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Name <span>*</span> :{" "}
            </p>
            <Select
              showSearch
              value={form.fullname || undefined}
              loading={dealers.loading}
              onChange={(value) => handleDropdownChange("dealerId", value)}
              style={{ width: "100%" }}
              placeholder="Search to Select"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {[
                {
                  user_first_name: "NOT ON THE LIST DEALER",
                  user_last_name: "",
                  _id: "0",
                },
                {
                  user_first_name: "NOT ON THE LIST DIRECT SELLER",
                  user_last_name: "",
                  _id: "1",
                },
                ...dealers.data,
              ].map((el, i) => (
                <Select.Option key={i} value={el._id}>
                  {`${el.user_first_name} ${el.user_last_name}`}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Mobile Number <span>*</span> :{" "}
            </p>
            <Input
              value={form.dealerMobileNumber}
              prefix={<GoDeviceMobile />}
              onChange={(text) => handleFieldChange("dealerMobileNumber", text)}
              disabled={
                form.dealerId === "0" || form.dealerId === "1" ? false : true
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Email:</p>
            <Input
              value={form.dealerEmail}
              prefix={<MdEmail />}
              onChange={(text) => handleFieldChange("dealerEmail", text)}
              disabled={
                form.dealerId === "0" || form.dealerId === "1" ? false : true
              }
            />
          </div>
        </Col>
      </Row>

      {(form.dealerId === "0" || form.dealerId === "1") && (
        <Row>
          <Col span={8}>
            <div className="form-fields">
              <p className="form-field-label">
                First Name <span>*</span> :{" "}
              </p>
              <Input
                value={form.dealerFirstName}
                onChange={(text) => handleFieldChange("dealerFirstName", text)}
              />
            </div>
          </Col>
          <Col span={8}>
            <div className="form-fields">
              <p className="form-field-label">Last Name: </p>
              <Input
                value={form.dealerLastName}
                onChange={(text) => handleFieldChange("dealerLastName", text)}
              />
            </div>
          </Col>
        </Row>
      )}

      <Divider />

      {form.role === "Advertiser" ? (
        <div>
          <div className="header-container">
            <p className="header">Package Options</p>
            <p className="sub-header">
              note: (*) for advertisers they must select a plan
            </p>
          </div>
          <Row>
            {packages.map((item, index) => (
              <Col span={8} key={index}>
                <div
                  className={`package-card-container ${
                    form.packageId === item._id ? "active" : ""
                  }`}
                  onClick={() => handleSelectPackage(item._id)}
                >
                  <div className="package-title">
                    <p>{item.package_name}</p>
                    <p>S$ {item.package_cost}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
          <Divider />
        </div>
      ) : null}

      <div className="header-container">
        <p className="header">Car Details</p>
        <p className="sub-header">
          note: (*) fields are required to be filled up
        </p>
      </div>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Car Title <span>*</span> :{" "}
            </p>
            <Input
              value={form.carName}
              onChange={(text) => handleFieldChange("carName", text)}
              maxLength={60}
              showCount
              suffix={
                <FieldSuffix
                  TooltipData={() => (
                    <p>
                      <strong>Car Brand & display as Title</strong>
                      <br />
                      Eg: Toyota 1.5A Vios
                    </p>
                  )}
                />
              }
            />
          </div>
        </Col>
        {/* <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Car Plate Number <span>*</span> :{" "}
            </p>
            <Input
              value={form.plateNumber.toUpperCase()}
              onChange={(text) => handleFieldChange("plateNumber", text)}
              suffix={
                <FieldSuffix
                  TooltipData={() => (
                    <p >
                      This car plate number field will not be shown in the ad.
                      It is for verification purpose.
                    </p>
                  )}
                />
              }
            />
          </div>
        </Col> */}
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Selling Price <span>*</span> :{" "}
            </p>
            <Input
              prefix={
                <div className="fieldPrefix">
                  <p>BND</p>
                </div>
              }
              value={getCommaSeparatedTwoDecimalsNumber(form.askingPrice)}
              onChange={(e) => {
                handleNumberFieldChange(
                  "askingPrice",
                  e.target.value == "" ? 0 : e.target.value.split(",").join(""),
                );
              }}
            />
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Car Brand <span>*</span> :{" "}
            </p>
            <Select
              showSearch
              value={form.carBrand || undefined}
              loading={brands.loading}
              onChange={(value) => handleDropdownChange("carBrand", value)}
              style={{ width: "100%" }}
              placeholder="Search to Select"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
            >
              {brands.data.map((el, i) => (
                <Select.Option key={i} value={el._id}>
                  {el.name}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Car Model <span>*</span> :{" "}
            </p>
            <Select
              showSearch
              value={form.carModel || undefined}
              disabled={!models?.data?.length}
              loading={models.loading && form.carBrand}
              onChange={(value) => handleDropdownChange("carModel", value)}
              style={{ width: "100%" }}
              placeholder={
                models.loading
                  ? `Fetching list of models`
                  : !models.data.length
                    ? `No model available in this brand`
                    : `Search to Select`
              }
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
            >
              {models?.data?.map((el, i) => (
                <Select.Option key={i} value={el._id}>
                  {el.name}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Vehicle / Body Type <span>*</span> :{" "}
            </p>
            <Select
              showSearch
              value={form.vehicleType || undefined}
              onChange={(value) => handleDropdownChange("vehicleType", value)}
              style={{ width: "100%" }}
              placeholder="Search to Select."
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              // filterSort={(optionA, optionB) =>
              //   optionA.children
              //     .toLowerCase()
              //     .localeCompare(optionB.children.toLowerCase())
              // }
            >
              {vehicleTypes.map((vehicle, i) => (
                <Select.Option key={i} value={vehicle}>
                  {vehicle}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Registration Date <span>*</span> :{" "}
            </p>
            <Space>
              <div className="datepicker">
                <DatePicker
                  format="DD-MMM-YYYY"
                  style={{ width: "100%" }}
                  value={
                    isNaN(Date.parse(form.registrationDate)) ||
                    !form.registrationDate
                      ? moment("01/01/2010", "DD-MM-YYYY")
                      : moment(form.registrationDate)
                  }
                  onChange={(date, dateString) =>
                    onDateFieldChange("registrationDate", dateString)
                  }
                />
              </div>
            </Space>
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label"> Fuel Type : </p>
            <Select
              showSearch
              value={form.specifications?.fuelType?.value || null}
              onChange={(value) =>
                handleDropdownChange("fuelType", value, "Fuel Type", "engine")
              }
              style={{ width: "100%" }}
              placeholder="Search to Select."
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              // filterSort={(optionA, optionB) =>
              //   optionA.children
              //     .toLowerCase()
              //     .localeCompare(optionB.children.toLowerCase())
              // }
            >
              {fuelTypes.map((fuel, i) => (
                <Select.Option key={i} value={fuel}>
                  {fuel}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Pri Color <span>*</span> :{" "}
            </p>
            <Select
              showSearch
              value={form.color ?? undefined}
              onChange={(value) => handleDropdownChange("color", value)}
              style={{ width: "100%" }}
              placeholder="Select Color."
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
            >
              <Select.Option value="black">Black</Select.Option>
              <Select.Option value="grey">Grey</Select.Option>
              <Select.Option value="white">White</Select.Option>
              <Select.Option value="beige">Beige</Select.Option>
              <Select.Option value="gold">Gold</Select.Option>
              <Select.Option value="red">Red</Select.Option>
              <Select.Option value="blue">Blue</Select.Option>
              <Select.Option value="yellow">Yellow</Select.Option>
              <Select.Option value="green">Green</Select.Option>
              <Select.Option value="orange">Orange</Select.Option>
              <Select.Option value="pink">Pink</Select.Option>
              <Select.Option value="purple">Purple</Select.Option>
              <Select.Option value="brown">Brown</Select.Option>
              <Select.Option value="silver">Silver</Select.Option>
              <Select.Option value="maroon">Maroon</Select.Option>
            </Select>
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Mileage <span>*</span> :{" "}
            </p>
            <Input
              value={getCommaSeparatedTwoDecimalsNumber(form.mileage)}
              onChange={(e) => {
                handleNumberFieldChange(
                  "mileage",
                  e.target.value == "" ? 0 : e.target.value.split(",").join(""),
                );
              }}
              suffix={
                <div className="fieldPrefix">
                  <p>km</p>
                </div>
              }
            />
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Ownership : </p>
            <Select
              placeholder="Select Ownership"
              value={form.numberOfOwners}
              onChange={(value) =>
                handleDropdownChange("numberOfOwners", value)
              }
              style={{
                width: "100%",
              }}
              options={numberOfOwners}
            />
          </div>
        </Col>

        {/* <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Road Tax : </p>
            <Input
              prefix={
                <div className="fieldPrefix">
                  <p>BND</p>
                </div>
              }
              value={getCommaSeparatedTwoDecimalsNumber(form.roadTax)}
              onChange={(e) => {
                handleNumberFieldChange(
                  "roadTax",
                  e.target.value == "" ? 0 : e.target.value.split(",").join(""),
                );
              }}
            />
          </div>
        </Col> */}

        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label"> Engine CC :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    {" "}
                    Engine CC input value min 100 to max 9999.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              type="number"
              value={form.specifications?.engineCap?.value}
              onChange={(e) => {
                handleNumberFieldChange("engineCap", e.target.value, 4);
              }}
              suffix={
                <div className="fieldPrefix">
                  <p>CC</p>
                </div>
              }
            />
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label"> Power :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    {" "}
                    Power input value is max 9999.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              type="number"
              value={form.specifications?.peakPower?.value}
              onChange={(e) => {
                handleNumberFieldChange(
                  "peakPower",
                  e.target.value,
                  "Power",
                  "engine",
                  5,
                );
              }}
              suffix={
                <div className="fieldPrefix">
                  <p>kw</p>
                </div>
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Transmission <span>*</span> :
            </p>
            <Select
              showSearch
              value={form.specifications?.transmission?.value || null}
              onChange={(value) =>
                handleDropdownChange(
                  "transmission",
                  value,
                  "Transmission",
                  "transmission",
                )
              }
              style={{ width: "100%" }}
              placeholder="Search to Select."
            >
              <Select.Option value={"Automatic"}>Automatic</Select.Option>
              <Select.Option value={"Manual"}>Manual</Select.Option>
            </Select>
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Category : </p>

            <Select
              mode="multiple"
              placeholder="Select Categories"
              value={form.categories}
              onChange={(value) =>
                handleMultipleDropdownChange("categories", value)
              }
              style={{
                width: "100%",
              }}
              options={usedCarCategories}
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">
                Manufacturing Year (Optional) :{" "}
              </p>
              <FieldSuffix
                TooltipData={() => (
                  <p>
                    The manufactured year of the car
                    <br />
                    e.g : 2020
                  </p>
                )}
              />
            </div>
            <Input
              placeholder="YYYY"
              type="number"
              value={form.manufacturedYear}
              onChange={(text) => handleFieldChange("manufacturedYear", text)}
              // suffix={
              //   <FieldSuffix
              //     TooltipData={() => (
              //       <p>
              //         The manufactured year of the car
              //         <br />
              //         e.g : 2020
              //       </p>
              //     )}
              //   />
              // }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label"> Optional Label :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p>Label shall be displayed on the picture of car.</p>
                )}
              />
            </div>
            <Select
              value={form.option_label_1}
              onChange={(value) =>
                handleDropdownChange("option_label_1", value)
              }
              style={{ width: "100%" }}
              placeholder="-- Select --"
              options={[
                { value: 'Electric Car', label: 'Electric Car' },
                { value: 'Hybrid Car', label: 'Hybrid Car' },
                { value: '$0 Downpayment', label: '$0 Downpayment' },
                { value: '1 Owner', label: '1 Owner' },
                { value: 'Low Mileage', label: 'Low Mileage' },
                { value: 'Consignment', label: 'Consignment' },
                { value: 'Showroom Unit', label: 'Showroom Unit' },
                { value: "Vehicle Inspected", label: "Vehicle Inspected" },
                { value: "Expat", label: "Expat" },
                // { value: 'Special Offer', label: 'Special Offer' },
              ]}
              allowClear
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div style={{ marginBottom: 10 }}>
              <Radio.Group
                onChange={(e) => handleRadioChange("videoType", e)}
                value={form.videoType}
              >
                <Radio value="youtube">Youtube</Radio>
                {/* <Radio value="tiktok">Tiktok</Radio> */}
                <Radio value="local">Local Drive</Radio>
              </Radio.Group>
            </div>

            {form?.videoType == "tiktok" ? (
              <>
                {/* <p className="form-field-label">Video Link : </p> */}
                <Input
                  value={form.tiktokVideo}
                  onChange={(text) => handleFieldChange("tiktokVideo", text)}
                  placeholder="Tiktok Video Link - Optional"
                />
                <p
                  className="form-field-label"
                  style={{ color: colorScheme.red, fontSize: 12, marginTop: 3 }}
                >
                  Video duration must not exceed 3 minutes!
                </p>
              </>
            ) : form?.videoType == "youtube" ? (
              <>
                {/* <p className="form-field-label">Video Link : </p> */}
                <Input
                  value={form.youtubeVideo}
                  onChange={(text) => handleFieldChange("youtubeVideo", text)}
                  placeholder="Youtube Video Link - Optional"
                />
                <p
                  className="form-field-label"
                  style={{ color: colorScheme.red, fontSize: 12, marginTop: 3 }}
                >
                  Video duration must not exceed 3 minutes!
                </p>
              </>
            ) : (
              <>
                <VideoUploader
                  localVideoUrl={form.localVideoUrl}
                  handelVideoChange={handelVideoChange}
                />
              </>
            )}
          </div>
        </Col>

        {(form.categories.includes("electric_car") || form.isElectric) && (
          <Col span={8}>
            <div className="form-fields">
              <p className="form-field-label">Drive Range : </p>
              <Input
                type="number"
                min="0"
                step="1"
                value={form.driveRange}
                onChange={(text) => handleFieldChange("driveRange", text)}
                suffix={
                  <div className="fieldPrefix">
                    <p>km</p>
                  </div>
                }
              />
            </div>
          </Col>
        )}

        {(form.categories.includes("hybrid") || form.isHybrid) && (
          <Col span={8}>
            <div className="form-fields">
              <p className="form-field-label">Fuel Consumption : </p>
              <Input
                type="number"
                min="0"
                step="1"
                value={form.fuelConsumptionKilometer}
                onChange={(text) =>
                  handleFieldChange("fuelConsumptionKilometer", text)
                }
                suffix={
                  <div className="fieldPrefix">
                    <p>km/L</p>
                  </div>
                }
              />
            </div>
          </Col>
        )}
      </Row>

      {/* <Row> */}

      {/* <Col span={8}>
          <div className="form-fields">
            <UploadFile
              label="Upload Blue Card"
              fileKey="blueCardFile"
              defaultFileUrl={form.blueCardFile}
              onUploadSuccess={handleUploadSuccess}
              required={true}
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <UploadFile
              label="Upload Inspection Report"
              fileKey="inspectionReportFile"
              defaultFileUrl={form.inspectionReportFile}
              onUploadSuccess={handleUploadSuccess}
            />
          </div>
        </Col> */}

      {/* {/* <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label"> Est Mth Instl. : </p>
            <Input
              prefix={
                <div className="fieldPrefix">
                  <p>S$</p>
                </div>
              }
              value={getCommaSeparatedTwoDecimalsNumber(form.monthly_installment_price)}
              onChange={(e) => {
                handleNumberFieldChange(
                  "monthly_installment_price",
                  e.target.value == "" ? 0 : e.target.value.split(",").join(""),
                  5
                );
              }}
              suffix={
                <FieldSuffix
                  TooltipData={() => (
                    <p >You may enter estimated monthly instalment plan.</p>
                  )}
                />
              }
            />
          </div>
        </Col>
      
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Road Tax : </p>
            <Input
              prefix={
                <div className="fieldPrefix">
                  <p>S$</p>
                </div>
              }
              value={getCommaSeparatedTwoDecimalsNumber(form.roadTax)}
              onChange={(e) => {
                handleNumberFieldChange(
                  "roadTax",
                  e.target.value == "" ? 0 : e.target.value.split(",").join("")
                );
              }}
            />
          </div>
        </Col> */}
      {/* </Row> */}

      <Divider />

      <Row align="middle">
        <Col span={8}>
          <div className="form-fields">
            <Checkbox
              valuePropName="checked"
              checked={form.isVerified}
              onChange={(e) => onCheckboxChange("isVerified", e)}
            >
              Trigger Email To Owner
            </Checkbox>
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields">
            <Checkbox
              valuePropName="checked"
              checked={form.isHybrid}
              onChange={(e) => onCheckboxChange("isHybrid", e)}
            >
              Hybrid
            </Checkbox>
          </div>
        </Col>

        <Col span={8}></Col>

        <Col span={8}>
          <div className="form-fields">
            <Checkbox
              valuePropName="checked"
              checked={form.isSendEmail}
              onChange={(e) => onCheckboxChange("isSendEmail", e)}
            >
              Trigger Email To All Sub
            </Checkbox>
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields">
            <Checkbox
              valuePropName="checked"
              checked={form.isElectric}
              onChange={(e) => onCheckboxChange("isElectric", e)}
            >
              Electric
            </Checkbox>
          </div>
        </Col>

        <Col span={8}></Col>
      </Row>

      {isEdit && (
        <>
          <Divider />

          <div className="header-container">
            <p className="header">Sale Advisers</p>
          </div>

          <Row>
            {saleAdvisers.length > 0 ? (
              saleAdvisers?.map((item, i) => (
                <Col span={8}>
                  <div className="form-fields" style={{ margin: 0 }}>
                    <Checkbox
                      name={item}
                      checked={form?.productAgents?.find(
                        (agent) => agent.fullName === item.fullName,
                      )}
                      onChange={(e) => handleUpdateAgent(e)}
                      disabled
                    >
                      {item.fullName} - {item?.sorting}
                    </Checkbox>
                  </div>
                </Col>
              ))
            ) : (
              <p style={{ color: "red" }}>
                No sales adviser found for this user
              </p>
            )}
          </Row>
        </>
      )}

      <Divider />

      <div className="header-container">
        <p className="header">Viewing Location</p>
        <p className="sub-header">
          note: (*) fields are required to be filled up
        </p>
      </div>

      <Row>
        {/* <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Pickup Address : </p>
            <Input
              value={form.address}
              onChange={(text) => handleFieldChange("address", text)}
              suffix={
                <FieldSuffix
                  TooltipData={() => (
                    <p>
                      Complete address where to pick-up the car.
                      <br />
                      This is an important field for filtering cars in the
                      system and analytics.
                    </p>
                  )}
                />
              }
            />
          </div>
        </Col> */}

        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">City : </p>
            <Select
              showSearch
              value={form.cityId}
              disabled={!cities.data}
              loading={cities.loading}
              onChange={(value) => handleDropdownChange("cityId", value)}
              style={{ width: "100%" }}
              placeholder="Search to Select"
              defaultActiveFirstOption={true}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
            >
              <Select.Option value={""}>All</Select.Option>
              {cities.data.map((el, i) => (
                <Select.Option key={i} value={el._id}>
                  {`${el.city}`}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Col>
      </Row>

      <Divider />

      <div className="header-container">
        <p className="header">Seller Notes (Optional) </p>
      </div>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Features : </p>
              <FieldSuffix
                TooltipData={() => (
                  <p>
                    <strong>
                      Features refers to functions in-built in your vehicle.
                    </strong>
                    <br />
                    Eg: Airbags, ABS, reliable, 6 cylinder, 6 seater, Sunroof,
                    multi-function steering, 2 moonroof.
                  </p>
                )}
              />
            </div>
            <Input.TextArea
              rows={8}
              value={form.features}
              onChange={(text) => handleFieldChange("features", text)}
              maxLength={150}
              showCount
              placeholder="Eg: Airbags, ABS, reliable, 6 cylinder, 6 seater, Sunroof, multi-function steering, 2 moonroof."
            />
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Accessories : </p>
              <FieldSuffix
                TooltipData={() => (
                  <p>
                    <strong>
                      Accessories refers to additional luxuries to your vehicle.
                    </strong>
                    <br />
                    Eg: 22' sports rims, full bodykit, new leather upholstery,
                    wireless phone charges.
                  </p>
                )}
              />
            </div>
            <Input.TextArea
              rows={8}
              value={form.accessories}
              onChange={(text) => handleFieldChange("accessories", text)}
              maxLength={150}
              showCount
              placeholder="Eg: 22' sports rims, full bodykit, new leather upholstery, wireless phone charges."
            />
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Description : </p>
              <FieldSuffix
                TooltipData={() => (
                  <p>
                    <strong>
                      Description will appear in the main page, so it is the
                      most important comment to add.
                    </strong>
                    <br />
                    Eg: Immediate condition, accident free, seldom use and well
                    maintain, family spare car, long leg room, neat and clean
                    exterior, perfect for family car, What's app for
                    appointment.
                  </p>
                )}
              />
            </div>
            <Input.TextArea
              rows={8}
              value={form.description}
              onChange={(text) => handleFieldChange("description", text)}
              maxLength={400}
              showCount
              placeholder="Eg: Immediate condition, accident free, seldom use and well maintain, family spare car, long leg room, neat and clean exterior, perfect for family car, What's app for appointment."
            />
          </div>
        </Col>
      </Row>

      <Divider />

      {/* <div className="header-container">
        <p className="header">Optional Details</p>
      </div>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Vehicle Number : </p>
            <Input
              value={form.vehicleNumber}
              onChange={(text) => handleFieldChange("vehicleNumber", text)}
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Vehicle Unit Number : </p>
            <Input
              value={form.vehicleUnitNumber}
              onChange={(text) => handleFieldChange("vehicleUnitNumber", text)}
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Vehicle Reference Number : </p>
            <Input
              value={form.vehicleReferenceNumber}
              onChange={(text) =>
                handleFieldChange("vehicleReferenceNumber", text)
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Vehicle Registration Card Number :{" "}
            </p>
            <Input
              value={form.vehicleRegistrationCardNumber}
              onChange={(text) =>
                handleFieldChange("vehicleRegistrationCardNumber", text)
              }
            />
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields" style={{ margin: "32px 0px" }}>
            <Checkbox
              valuePropName="checked"
              checked={form.isOffPeak}
              onChange={(e) => onCheckboxChange("isOffPeak", e)}
            >
              Tick if the car is an Off-Peak Car
            </Checkbox>
          </div>
        </Col>
        
      </Row> */}
    </div>
  );
};

export default CarDetails;
